import React from 'react';

import lockQuetionIcon from '../../../../../../../../../../assets/img/lock_question_white.png';

import styles from './QuestionContainerLockState.module.css';

export default function({ question }) {
  if (!question || !question.groupAndRandomiseLockedPosition) {
    return null;
  }

  return (
    <div className={styles.addToParentIconGroupedContainer}>
      <img src={lockQuetionIcon} alt="Lock icon" />
    </div>
  );
}
